import { ActionReducerMap } from '@ngrx/store';
import { regStoreReducer, RegState } from './reducers/home-page.reducer';
export interface RegModuleState {
  registration: RegState;
}

export const _regReducer: ActionReducerMap<RegModuleState> = {
  registration: regStoreReducer,
};
